import { render, staticRenderFns } from "./edit-instruction.vue?vue&type=template&id=3c4eef4b&scoped=true&"
import script from "./edit-instruction.vue?vue&type=script&lang=js&"
export * from "./edit-instruction.vue?vue&type=script&lang=js&"
import style0 from "./edit-instruction.vue?vue&type=style&index=0&id=3c4eef4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4eef4b",
  null
  
)

export default component.exports